import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export function initAnimProgram(){

    gsap.registerPlugin(ScrollTrigger);

    let currentIsDesktop: boolean = window.innerWidth > 991;

    (() => {
        if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
            console.warn("gsap или ScrollTrigger не подключены");
            return;
        }
        gsap.registerPlugin(ScrollTrigger);

        let currentIsDesktop: boolean = window.innerWidth > 991;
        let programItemsTL: gsap.core.Timeline | null = null;

        function initProgramItemsAnimation(): void {
            // Убиваем предыдущую TL/триггеры
            if (programItemsTL) {
                try {
                    programItemsTL.kill();
                } catch (e) {
                    console.error(e);
                }
                programItemsTL = null;
            }
            ScrollTrigger.getAll().forEach((t) => t.kill());

            const wrapper = document.querySelector<HTMLElement>(".program-items-wrapper");
            const container = document.querySelector<HTMLElement>(".program-items");
            const items = gsap.utils.toArray<HTMLElement>(".program-item");

            // Сбрасываем трансформы
            items.forEach((it) => gsap.set(it, { clearProps: "transform" }));
            if (wrapper) wrapper.style.height = "";

            if (!wrapper || !container || items.length === 0) return;

            // Мобильная версия — отключаем пин/анимацию
            if (window.innerWidth <= 991) {
                wrapper.style.height = "auto";
                return;
            }

            // Берём margin-bottom из CSS (если не задан — fallback 40)
            const cs = window.getComputedStyle(items[0]);
            const marginBottom = Math.max(0, parseFloat(cs.marginBottom) || 20);

            // Высоты элементов (без margin)
            const itemHeights: number[] = items.map((it) => it.offsetHeight);
            // Высоты с margin (для всех кроме последнего)
            const heightsWithMargin: number[] = itemHeights.map(
                (h, idx) => h + (idx < items.length - 1 ? marginBottom : 0)
            );

            const scaleStep = 0.02; // шаг уменьшения масштаба для элементов сверху
            const extraGap = 40; // запас пикселей между карточками
            const VISIBLE_PART = 10;
            const yTargets: number[] = [];
            // Смещения по Y
            items.forEach((it, i) => {
                if (i === 0) {
                    yTargets.push(0);
                } else {
                    let shift = 0;
                    for (let j = 0; j < i; j++) {
                        // высота карточки j минус "торчащий кусок"
                        shift += items[j].offsetHeight - VISIBLE_PART;
                    }
                    yTargets.push(-shift);
                }
            });

            const scaleTargets: number[] = items.map((_, i) =>
                +(1 - scaleStep * (items.length - i - 1)).toFixed(3)
            );

            // Общий сдвиг
            const containerHeight = container.offsetHeight;
            const totalShift = Math.abs(yTargets[yTargets.length - 1]) || 0;
            const extra = 50;
            const wrapperHeight = containerHeight + totalShift + extra;
            wrapper.style.height = containerHeight + "px";

            if (totalShift < 5) {
                items.forEach((it) => gsap.set(it, { clearProps: "transform" }));
                return;
            }

            // Длина скролла
            const scrollLength = Math.max(totalShift + extra, window.innerHeight * 1.2);

            programItemsTL = gsap.timeline({
                scrollTrigger: {
                    trigger: wrapper,
                    start: window.innerWidth < 1140 ? "top 10%" : "top 20%",
                    end: "+=" + scrollLength,
                    scrub: true,
                    pin: container,
                    anticipatePin: 1,
                },
            });

            // Анимация элементов
            programItemsTL.to(items, {
                y: (index: number) => yTargets[index] + "px",
                scale: (index: number) => scaleTargets[index],
                duration: 1,
                ease: "none",
                stagger: (index: number) => {
                    const pos = totalShift ? Math.abs(yTargets[index]) / totalShift : 0;
                    const multiplier = 0.9;
                    return pos * multiplier;
                },
            });
        }

        // Инициализация при загрузке
        if (document.querySelector(".program-item")) {
            initProgramItemsAnimation();
        }

        // Обработка ресайза
        let resizeTimeout: number | undefined;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(() => {
                const nowDesktop = window.innerWidth > 991;
                currentIsDesktop = nowDesktop;
                initProgramItemsAnimation();
            }, 120);
        });
    })();

}